import { Button, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useModalsContext } from '../../../../providers/ModalsProvider/Modals.context.ts';
import { eDeleteFunnelProgressModal } from './DeleteFunnelProgressModal.enum.ts';
import { RouterPaths } from '../../../../components/Router/Router.constants.ts';
import './DeleteFunnelProgressModal.styles.scss';
import { useEffect, useState } from 'react';

export default function DeleteFunnelProgressModal() {
  const { showDeleteFunnelModal, setShowDeleteFunnelModal } =
    useModalsContext();
  const { t } = useTranslation('pipe/funnel');
  const [funnelToSave, setFunnelToSave] = useState<string>('');
  const [stageToSave, setStageToSave] = useState<string>('');

  useEffect(() => {
    setFunnelToSave(localStorage.getItem('funnelToSaveLeads') || '');
    setStageToSave(localStorage.getItem('stageToSaveLeads') || '');
  }, []);

  return (
    <Modal
      className="SyncDeleteFunnelSuccess w-full max-w-4xl"
      open={showDeleteFunnelModal === eDeleteFunnelProgressModal.SUCCESS}
    >
      <div className="SyncDeleteFunnelSuccess__Container">
        <div className="SyncDeleteFunnelSuccess__Container__Body">
          <img
            src={'/images/sync/syncMobileSuccess.png'}
            alt="syncMobilePhone"
            className="SyncDeleteFunnelSuccess__Container__Image"
          />
          <strong className="SyncDeleteFunnelSuccess__Container__Title">
            {t('components.DeleteFunnelProgress.success.title')}
          </strong>
          <p className="SyncDeleteFunnelSuccess__Container__Description">
            {t('components.DeleteFunnelProgress.success.description', {
              funnelToSave,
              stageToSave,
            })}
          </p>

          <div className="SyncDeleteFunnelSuccess__Container__Bottom">
            <Button
              color="primary"
              className="text-base-100"
              onClick={() => {
                localStorage.removeItem('funnelToSaveLeads');
                localStorage.removeItem('stageToSaveLeads');
                setShowDeleteFunnelModal(eDeleteFunnelProgressModal.HIDDEN);
                window.open(RouterPaths.funnels, '_self');
              }}
            >
              {t('components.DeleteFunnelProgress.success.button')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
